// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"DK-z","upvoteIcon":"EK-z","downvoteIcon":"FK-z","feedbackIcon":"GK-z"};